module.exports = __webpack_public_path__ + "img/006_defaultroute.0d63512a.png";